<button routerLink="/wallet/admin/compliance-list" class="mt-4 ml-4"
  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
  onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
  <mat-icon>arrow_back</mat-icon> Regresar
</button>

<!-- ═══ Progreso del registro del usuario ═══
     100% lo marca `isCompleted`; el resto se calcula sobre los steps de
     `progress` que ya tienen información (completed: true). -->
<div *ngIf="hasRegistrationProgress" class="mt-4 mx-4"
  style="max-width: 900px; margin-left: auto; margin-right: auto; border: 1px solid #d1d5db; border-radius: 10px; padding: 14px 20px; background: white;">
  <div style="display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap;">
    <div style="display: flex; align-items: center; gap: 10px;">
      <mat-icon [style.color]="isRegistrationComplete ? '#16a34a' : '#1e5a3f'">
        {{ isRegistrationComplete ? 'verified' : 'assignment' }}
      </mat-icon>
      <span style="color: #374151; font-weight: 600; font-size: 0.95rem;">Progreso del registro</span>
      <span *ngIf="isRegistrationComplete"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; background: #dcfce7; color: #166534; font-weight: 700; font-size: 0.75rem;">
        <mat-icon style="font-size: 15px; width: 15px; height: 15px;">check_circle</mat-icon>
        Registro completo · 100%
      </span>
    </div>
    <span style="font-weight: 800; font-size: 1.15rem;"
      [style.color]="isRegistrationComplete ? '#16a34a' : '#1e5a3f'">
      {{ registrationProgressPercent }}%
    </span>
  </div>
  <div style="margin-top: 10px; height: 8px; border-radius: 999px; background: #e5e7eb; overflow: hidden;">
    <div [style.width.%]="registrationProgressPercent"
      [style.background]="isRegistrationComplete ? '#16a34a' : '#1e5a3f'"
      style="height: 100%; border-radius: 999px; transition: width 0.3s ease;"></div>
  </div>
</div>

<!-- ═══ Cupo de registro ═══
     Estado (nivel/bloqueo) del endpoint 1 + consumo del endpoint 2. El
     consumo solo se muestra si el cliente sigue PRE-activo (aplica). -->
<div *ngIf="showCupoModule" class="mt-4 mx-4"
  style="max-width: 900px; margin-left: auto; margin-right: auto; border: 1px solid #d1d5db; border-radius: 10px; padding: 16px 20px; background: white;">
  <div style="display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px;">
    <mat-icon style="color: #1e5a3f;">account_balance_wallet</mat-icon>
    <span style="color: #374151; font-weight: 700; font-size: 1rem;">Cupo de registro</span>

    <!-- Chip de nivel: PRE (naranja, tope rige) / COMPLETO (verde, sin tope) -->
    <span
      style="display: inline-flex; align-items: center; padding: 3px 10px; border-radius: 999px; font-weight: 700; font-size: 0.72rem; letter-spacing: 0.03em;"
      [style.background]="cupoEstado?.nivel === 'COMPLETO' ? '#dcfce7' : '#ffedd5'"
      [style.color]="cupoEstado?.nivel === 'COMPLETO' ? '#166534' : '#9a3412'">
      {{ cupoEstado?.nivel === 'COMPLETO' ? 'Sin restricción' : 'Pre-aprobado' }}
    </span>

    <!-- Badge bloqueado -->
    <span *ngIf="cupoBloqueado"
      style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; background: #fee2e2; color: #991b1b; font-weight: 700; font-size: 0.72rem;">
      <mat-icon style="font-size: 15px; width: 15px; height: 15px;">block</mat-icon>
      Bloqueado
    </span>
  </div>

  <!-- Tope del cupo: viene del endpoint de estado (endpoint 1) y se
       muestra SIEMPRE que exista el cupo, aunque el consumo no aplique. -->
  <div *ngIf="cupoEstado?.tope != null"
    style="display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; margin-bottom: 12px;">
    <span style="color: #6b7280; font-size: 0.85rem;">Tope de registro:</span>
    <strong style="color: #111827; font-size: 0.95rem;">${{ formatCupoClp(cupoEstado?.tope) }} CLP</strong>
    <span *ngIf="cupoEstado?.activo === false"
      style="padding: 2px 8px; border-radius: 999px; background: #f3f4f6; color: #6b7280; font-size: 0.7rem; font-weight: 700;">
      Tope inactivo
    </span>
  </div>

  <!-- Gasto acumulado (salidas totales, endpoint 3): útil aunque el cupo
       no aplique. -->
  <div *ngIf="cupoSalidas"
    style="display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; margin-bottom: 12px;">
    <span style="color: #6b7280; font-size: 0.85rem;">Gasto acumulado:</span>
    <strong style="color: #111827; font-size: 0.95rem;">${{ formatCupoClp(cupoSalidas.salidasClp) }} CLP</strong>
  </div>

  <!-- Motivo de bloqueo -->
  <div *ngIf="cupoBloqueado && cupoEstado?.motivoBloqueo"
    style="margin-bottom: 12px; padding: 8px 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; color: #991b1b; font-size: 0.85rem;">
    {{ cupoEstado?.motivoBloqueo }}
  </div>

  <!-- Consumo: solo cuando el cliente sigue PRE-activo -->
  <ng-container *ngIf="cupoConsumoAplica; else cupoSinConsumo">
    <div style="display: flex; justify-content: space-between; align-items: baseline; gap: 12px; flex-wrap: wrap; margin-bottom: 6px;">
      <span style="color: #6b7280; font-size: 0.85rem;">
        Utilizado:
        <strong style="color: #111827;">${{ formatCupoClp(cupoConsumo?.consumido) }}</strong>
        de ${{ formatCupoClp(cupoConsumo?.tope) }} CLP
      </span>
      <span style="font-weight: 800; font-size: 1.05rem;" [style.color]="cupoBarColor">
        {{ cupoPorcentaje }}%
      </span>
    </div>
    <div style="height: 10px; border-radius: 999px; background: #e5e7eb; overflow: hidden;">
      <div [style.width.%]="cupoPorcentaje > 100 ? 100 : cupoPorcentaje"
        [style.background]="cupoBarColor"
        style="height: 100%; border-radius: 999px; transition: width 0.3s ease;"></div>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: baseline; margin-top: 6px; gap: 12px; flex-wrap: wrap;">
      <span style="color: #6b7280; font-size: 0.8rem;">
        Disponible:
        <strong style="color: #111827;">${{ formatCupoClp(cupoConsumo?.disponible) }} CLP</strong>
      </span>
      <span *ngIf="cupoLimiteSuperado"
        style="display: inline-flex; align-items: center; gap: 4px; color: #dc2626; font-weight: 700; font-size: 0.8rem;">
        <mat-icon style="font-size: 15px; width: 15px; height: 15px;">warning</mat-icon>
        Límite superado
      </span>
    </div>
  </ng-container>

  <ng-template #cupoSinConsumo>
    <p *ngIf="cupoConsumoMensaje" style="margin: 0; color: #6b7280; font-size: 0.88rem;">
      {{ cupoConsumoMensaje }}
    </p>
  </ng-template>

  <!-- Acciones del operador: bloquear (pide motivo) / desbloquear -->
  <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; padding-top: 14px; border-top: 1px solid #f3f4f6;">
    <button
      *ngIf="!cupoBloqueado"
      type="button"
      (click)="bloquearCupo()"
      [disabled]="cupoActionLoading"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 8px; border: 1px solid #dc2626; background: white; color: #dc2626; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      <mat-icon style="font-size: 17px; width: 17px; height: 17px;">block</mat-icon>
      Bloquear acceso
    </button>
    <button
      *ngIf="cupoBloqueado"
      type="button"
      (click)="desbloquearCupo()"
      [disabled]="cupoActionLoading"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: 8px; border: none; background: #1e5a3f; color: white; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      <mat-icon style="font-size: 17px; width: 17px; height: 17px;">lock_open</mat-icon>
      Desbloquear
    </button>
  </div>
</div>

<!-- Error al consultar el cupo (p. ej. 403 sin permisos) -->
<div *ngIf="cupoError" class="mt-4 mx-4"
  style="max-width: 900px; margin-left: auto; margin-right: auto; padding: 10px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; color: #991b1b; font-size: 0.85rem;">
  {{ cupoError }}
</div>

<mat-tab-group class="m-2 sm:m-4">
  <mat-tab *ngIf="!isCompany && user?.politicamenteExpuesto === 1" label="PEP">
    <div class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">
      <div style="border: 1px solid #fecaca; border-radius: 8px; overflow: hidden;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #fef2f2, #fff1f2);">
          <mat-icon style="color: #dc2626; font-size: 22px; width: 22px; height: 22px;">warning</mat-icon>
          <span style="color: #991b1b; font-weight: 600; font-size: 1rem;">
            Usuario es Persona Políticamente Expuesta (PEP)
          </span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1" *ngIf="pepData?.data?.dataInfo">
            <ng-container *ngFor="let key of objectKeys(pepData.data.dataInfo)">
              <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(key) }}</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ pepData.data.dataInfo[key] }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab
    [label]="!isCompany ? 'Datos generales' : 'Datos representante legal'"
  >
    <div *ngIf="user" class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">

      <!-- ═══ Sección: Información personal ═══ -->
      <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">person</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Información personal</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Usuario ID</span>
              <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ user.usuarioId }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nombre</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1?.nombres || user.nombre }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Apellidos</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1?.apellidos || user.apellidos }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Documento</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ isCompany ? 'RUT' : user.tipoId }} {{ companyData1?.rut || user.numeroId }}</span>
            </div>
            <div *ngIf="!isCompany" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Fecha de nacimiento</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.fechaNacimiento }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Teléfono</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.prefijoTelefono }} {{ user.telefono }}</span>
            </div>
            <div *ngIf="!isCompany || companyData1" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nacionalidad</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1?.nacionalidad || user.nacionalidad }}</span>
            </div>
            <div *ngIf="!isCompany" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">País residencia</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.paisResidencia }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Usuario Aguacate</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
                <ng-container *ngIf="fichaReferidos?.llave">&#64;{{ fichaReferidos?.llave }}</ng-container>
                <span *ngIf="fichaReferidos && !fichaReferidos.llave"
                      style="color: #9ca3af;">Todav&iacute;a no lo cre&oacute;</span>
              </span>
            </div>
            <div *ngIf="fichaReferidos?.invitadoPor" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Lo invit&oacute;</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
                {{ fichaReferidos?.invitadoPor?.nombre || '&#8212;' }}
                (&#64;{{ fichaReferidos?.invitadoPor?.llave }})
                <span *ngIf="fichaReferidos?.invitadoPor?.origen === 'RECLAMO'"
                      style="color: #8a6a22; font-size: 0.78rem;">&#183; cargado a mano</span>
              </span>
            </div>
            <div *ngIf="fichaReferidos && fichaReferidos.trajo.invitados > 0"
                 style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Referidos que trajo</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
                {{ fichaReferidos.trajo.conFondeo }} de {{ fichaReferidos.trajo.invitados }} cargaron
                &#183; cobr&oacute; {{ fichaReferidos.trajo.cobradoUsdt }} {{ fichaReferidos.trajo.moneda || 'USDT' }}
                <!-- Muchos invitados sin un solo fondeo es el patron que hay que
                     mirar: registros que no dejaron plata. -->
                <span *ngIf="fichaReferidos.trajo.invitados >= 5 && fichaReferidos.trajo.conFondeo === 0"
                      style="color: #A3432B; font-size: 0.78rem; font-weight: 600;">
                  &#183; ninguno fonde&oacute;
                </span>
              </span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Correo</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem; word-break: break-all;">{{ user.email }}</span>
            </div>
            <div *ngIf="!isCompany" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Profesión</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.profesion }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Datos adicionales representante (nuevo flujo empresa) ═══ -->
      <div *ngIf="isCompany && companyData1" style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">location_on</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Datos adicionales del representante</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
            <div *ngIf="companyData1.direccion_particular" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Dirección</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.direccion_particular }}</span>
            </div>
            <div *ngIf="companyData1.comuna" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Comuna</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.comuna }}</span>
            </div>
            <div *ngIf="companyData1.ciudad" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Ciudad</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.ciudad }}</span>
            </div>
            <div *ngIf="companyData1.pais_direccion" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">País dirección</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.pais_direccion }}</span>
            </div>
            <div *ngIf="companyData1.porcentaje_participacion" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Participación</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.porcentaje_participacion }}%</span>
            </div>
            <div *ngIf="companyData1.fecha_vencimiento_dni" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Vencimiento DNI</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.fecha_vencimiento_dni }}</span>
            </div>
          </div>

          <!-- PEP del representante -->
          <div *ngIf="companyData1.es_pep !== null && companyData1.es_pep !== undefined && companyData1.es_pep !== ''" style="margin-top: 12px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
              <span style="color: #6b7280; font-size: 0.8rem;">PEP</span>
              <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                [style.background]="companyData1.es_pep === true ? '#dc2626' : '#16a34a'">
                {{ companyData1.es_pep === true ? 'Sí' : 'No' }}
              </span>
            </div>
            <div *ngIf="companyData1.es_pep === true" class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1"
              style="padding: 10px 14px; border-radius: 6px; background: #fef2f2; border: 1px solid #fecaca;">
              <div *ngIf="companyData1.pep_funcion" style="padding: 3px 0;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Función PEP</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.pep_funcion }}</span>
              </div>
              <div *ngIf="companyData1.pep_institucion" style="padding: 3px 0;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Institución PEP</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.pep_institucion }}</span>
              </div>
              <div *ngIf="companyData1.pep_fecha_inicio" style="padding: 3px 0;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">PEP desde</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.pep_fecha_inicio }}</span>
              </div>
              <div *ngIf="companyData1.pep_fecha_termino" style="padding: 3px 0;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">PEP hasta</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyData1.pep_fecha_termino }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Verificación facial (nuevo flujo empresa) ═══ -->
      <div *ngIf="isNewCompanyFlow && companyRegistration?.data?.companyDocuments?.data4?.faceVerification"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">face</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Verificación facial</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 10px;">
            <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
              [style.background]="companyRegistration.data.companyDocuments.data4.faceVerification.similarity >= 80 ? '#16a34a' : companyRegistration.data.companyDocuments.data4.faceVerification.similarity >= 50 ? '#ca8a04' : '#dc2626'">
              Similitud {{ companyRegistration.data.companyDocuments.data4.faceVerification.similarity }}%
            </span>
            <span *ngIf="companyRegistration.data.companyDocuments.data4.faceVerification.needsManualReview"
              style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #ca8a04;">
              Requiere revisión manual
            </span>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Documentos de identidad ═══ -->
      <div *ngIf="!idImagesLoaded" style="display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 24px; margin-bottom: 12px; border: 1px solid #d1d5db; border-radius: 8px;">
        <mat-spinner diameter="32"></mat-spinner>
        <span style="color: #6b7280; font-size: 0.85rem;">Cargando documentos de identidad...</span>
      </div>
      <div *ngIf="idImagesLoaded"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">badge</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Documentos de identidad</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="flex flex-col items-center">
            <!-- Documento frontal -->
            <ng-container *ngIf="mostarFrontal">
              <span style="color: #6b7280; font-size: 0.8rem; display: block; margin-bottom: 8px;">Documento identidad frontal</span>
              <img *ngIf="fotoIdFrontal" [src]="fotoIdFrontal" (error)="fotoIdFrontal = ''" style="max-width: 100%; max-height: 400px; width: auto; height: auto; object-fit: contain; border-radius: 8px; border: 1px solid #e5e7eb;" />
              <div *ngIf="!fotoIdFrontal" style="display: flex; align-items: center; gap: 8px; padding: 16px 20px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 8px;">
                <mat-icon style="color: #9ca3af; font-size: 20px; width: 20px; height: 20px;">image_not_supported</mat-icon>
                <span style="color: #9ca3af; font-size: 0.9rem;">No está registrada la imagen</span>
              </div>
            </ng-container>
            <!-- Documento posterior -->
            <ng-container *ngIf="!mostarFrontal">
              <span style="color: #6b7280; font-size: 0.8rem; display: block; margin-bottom: 8px;">Documento identidad posterior</span>
              <img *ngIf="fotoIdPosterior" [src]="fotoIdPosterior" (error)="fotoIdPosterior = ''" style="max-width: 100%; max-height: 400px; width: auto; height: auto; object-fit: contain; border-radius: 8px; border: 1px solid #e5e7eb;" />
              <div *ngIf="!fotoIdPosterior" style="display: flex; align-items: center; gap: 8px; padding: 16px 20px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 8px;">
                <mat-icon style="color: #9ca3af; font-size: 20px; width: 20px; height: 20px;">image_not_supported</mat-icon>
                <span style="color: #9ca3af; font-size: 0.9rem;">No está registrada la imagen</span>
              </div>
            </ng-container>
            <div style="margin-top: 12px;">
              <button (click)="mostarFrontal = !mostarFrontal"
                style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
                onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px;">rotate_right</mat-icon>
                Girar
              </button>
            </div>
            <!-- Selfie -->
            <div style="margin-top: 16px; border-top: 1px solid #f3f4f6; padding-top: 16px; width: 100%; text-align: center;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block; margin-bottom: 8px;">Selfie</span>
              <img *ngIf="selfieUrl" [src]="selfieUrl" style="max-width: 100%; max-height: 400px; width: auto; height: auto; object-fit: contain; border-radius: 8px; border: 1px solid #e5e7eb; display: block; margin: 0 auto;" />
              <div *ngIf="!selfieUrl" style="display: inline-flex; align-items: center; gap: 8px; padding: 16px 20px; background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 8px;">
                <mat-icon style="color: #9ca3af; font-size: 20px; width: 20px; height: 20px;">image_not_supported</mat-icon>
                <span style="color: #9ca3af; font-size: 0.9rem;">No está registrada la imagen</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </mat-tab>
  <mat-tab label="Datos empresa" *ngIf="isCompany">
    <div *ngIf="user" class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">

      <!-- ═══ Sección: Información de la empresa ═══ -->
      <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">business</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Información de la empresa</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nombre o razón social</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.razonSocial }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nombre comercial</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.nombreComercial }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">RUT</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.rutEmpresa }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Domicilio fiscal</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.domicilioFiscal }}</span>
            </div>
            <!-- Campos adicionales del nuevo flujo (data2) -->
            <ng-container *ngIf="isNewCompanyFlow && companyRegistration?.data?.companyDocuments?.data2">
              <div *ngIf="companyRegistration.data.companyDocuments.data2.giroComercial" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Giro comercial</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyRegistration.data.companyDocuments.data2.giroComercial }}</span>
              </div>
              <div *ngIf="companyRegistration.data.companyDocuments.data2.fechaConstitucion" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Fecha constitución</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyRegistration.data.companyDocuments.data2.fechaConstitucion }}</span>
              </div>
              <div *ngIf="companyRegistration.data.companyDocuments.data2.motivoRelacion2" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Motivo relación</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ companyRegistration.data.companyDocuments.data2.motivoRelacion2 }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Análisis del e-RUT ═══
           Va antes de los documentos porque no es un archivo mas: es el
           veredicto que decide si el documento societario es confiable. -->
      <div *ngIf="erutAnalisis"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">fact_check</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Análisis del e-RUT</span>
        </div>
        <div style="padding: 16px 20px; background: white;">

          <!-- Veredicto -->
          <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-bottom: 14px;">
            <span *ngIf="erutAnalisis.recommendation === 'accept'"
              style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #16a34a;">
              Sin señales de manipulación
            </span>
            <span *ngIf="erutAnalisis.recommendation === 'review'"
              style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #ca8a04;">
              Requiere revisión manual
            </span>
            <span *ngIf="erutAnalisis.recommendation === 'reject'"
              style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #dc2626;">
              Evidencia de manipulación
            </span>
            <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: #374151; background: #f3f4f6;">
              Integridad {{ erutAnalisis.integrityScore }}/100
            </span>
            <button *ngIf="erutAnalisis.s3Key" (click)="openFilePreview(erutAnalisis.s3Key, 'e-RUT del SII')"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver el documento
            </button>
            <!-- Registros analizados antes de que el PDF se archivara: queda el
                 veredicto pero no el archivo. -->
            <span *ngIf="!erutAnalisis.s3Key"
              style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: #78350f; background: #fef3c7;">
              Documento no archivado
            </span>
          </div>

          <!-- Campos leidos del documento -->
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">RUT en el e-RUT</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.rut || '—' }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Razón social</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.razonSocial || '—' }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">N° de serie</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.serie || '—' }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Dirección principal</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.direccion || '—' }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Emisión</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.fechaEmision || '—' }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Glosa de actividad</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ erutAnalisis.glosaActividad || '—' }}</span>
            </div>
          </div>

          <!-- Quien lo descargo del SII: es el cruce contra el representante legal -->
          <div style="margin-top: 12px; padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
            <span style="color: #6b7280; font-size: 0.8rem; display: block; margin-bottom: 4px;">Descargado del SII por</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
              {{ erutAnalisis.usuario || 'No informado' }}
              <ng-container *ngIf="erutAnalisis.rutUsuario"> — {{ erutAnalisis.rutUsuario }}</ng-container>
            </span>
          </div>

          <!-- El limite del analisis. Va siempre, no solo cuando falla: un
               'accept' no significa documento autentico. -->
          <div style="margin-top: 12px; display: flex; gap: 8px; padding: 10px 14px; border-radius: 6px; background: #fffbeb; border: 1px solid #fde68a;">
            <mat-icon style="color: #b45309; font-size: 18px; width: 18px; height: 18px; flex-shrink: 0;">info</mat-icon>
            <span style="color: #78350f; font-size: 0.8rem; line-height: 1.45;">
              El e-RUT no lleva firma criptográfica: este análisis descarta manipulación
              del documento, <strong>no confirma que sea auténtico</strong>. Solo el SII
              puede confirmarlo. Además, el QR respalda únicamente RUT, razón social,
              dirección y serie: la fecha de emisión, la glosa y los datos de quien lo
              descargó se pueden editar sin que el análisis lo detecte.
            </span>
          </div>

          <div *ngIf="erutAnalisis.sha256" style="margin-top: 10px;">
            <span style="color: #6b7280; font-size: 0.75rem;">Huella del archivo analizado (SHA-256): {{ erutAnalisis.sha256 }}</span>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Documentos ═══ -->
      <div *ngIf="documentosSociedad.length || (!companyData6 && (estatuto || documentoIdTributario))"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">folder_open</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Documentos</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <!-- Nuevo flujo: se recorre `data6` en vez de enumerar documentos
                 a mano. Antes solo se listaban escritura, vigencia y carpeta
                 tributaria: los que el formulario pide segun el tipo de
                 sociedad (Conservador, Diario Oficial) y los adicionales
                 quedaban guardados y sin mostrar. -->
            <div *ngFor="let doc of documentosSociedad"
              style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
              <mat-icon style="color: #1e5a3f; font-size: 20px; width: 20px; height: 20px;">description</mat-icon>
              <span style="color: #374151; font-weight: 500; flex: 1; font-size: 0.9rem;">{{ doc.label }}</span>
              <button (click)="openFilePreview(doc.s3Key, doc.label)"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
              </button>
            </div>
            <!-- Flujo legacy -->
            <div *ngIf="!companyData6 && estatuto"
              style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
              <mat-icon style="color: #1e5a3f; font-size: 20px; width: 20px; height: 20px;">description</mat-icon>
              <span style="color: #374151; font-weight: 500; flex: 1; font-size: 0.9rem;">Estatuto</span>
              <button (click)="openTab(estatuto)"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
              </button>
            </div>
            <div *ngIf="!companyData6 && documentoIdTributario"
              style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
              <mat-icon style="color: #1e5a3f; font-size: 20px; width: 20px; height: 20px;">description</mat-icon>
              <span style="color: #374151; font-weight: 500; flex: 1; font-size: 0.9rem;">Identificación Tributaria</span>
              <button (click)="openTab(documentoIdTributario)"
                style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </mat-tab>
  <mat-tab label="KYC">
    <div class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">

      <!-- ═══ Sección: Estado y control Compliance ═══ -->
      <div *ngIf="user" style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">verified_user</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Estado y control Compliance</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <form [formGroup]="formCompliance" *ngIf="formCompliance">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Columna: Estado + Acciones -->
              <div>
                <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6; margin-bottom: 12px;">
                  <span style="color: #6b7280; font-size: 0.8rem; display: block;">Estado Compliance</span>
                  <span style="font-weight: 500; font-size: 0.9rem; display: inline-flex; align-items: center; gap: 6px;">
                    <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                      [style.background]="user.estadoComplianceID === 3 ? '#16a34a' : user.estadoComplianceID === 1 ? '#dc2626' : user.estadoComplianceID === 2 ? '#111827' : '#ca8a04'">
                      {{ user.estadoCompliance.descripcion }}
                    </span>
                  </span>
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                  <button (click)="aproveCompliance()" [disabled]="user.estadoComplianceID === 3"
                    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
                    onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">check</mat-icon> Aprobar
                  </button>
                  <button (click)="rejectUser()" [disabled]="user.estadoComplianceID === 1"
                    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">cancel</mat-icon> Rechazar
                  </button>
                  <button [disabled]="user.estadoComplianceID === 2" (click)="backlistUser()"
                    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">error</mat-icon> Black list
                  </button>
                  <button (click)="openCreateDataUpdateRequestModal()"
                    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'"
                    title="Crear una solicitud de actualización para este cliente">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">fact_check</mat-icon> Solicitar actualización
                  </button>
                  <button (click)="goToDataUpdateRequests()"
                    style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #f0fdf4; color: #1C593D; border: 1px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'"
                    title="Abrir el dashboard de solicitudes de actualización">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">dashboard</mat-icon> Ver solicitudes
                  </button>
                </div>
              </div>
              <!-- Columna: Checkboxes -->
              <div>
                <div style="padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
                  <p style="margin: 4px 0;"><mat-checkbox formControlName="politicamenteExpuesto">PEP</mat-checkbox></p>
                  <p style="margin: 4px 0;"><mat-checkbox formControlName="esRTP">RTP</mat-checkbox></p>
                  <p style="margin: 4px 0;"><mat-checkbox formControlName="esListaONU">LISTA ONU</mat-checkbox></p>
                  <div *ngIf="user.fuenteComplianceID === 2" style="color: #6b7280; font-size: 0.75rem; margin-top: 6px;">
                    *Información traída de REGCHEQ
                  </div>
                </div>
                <div style="margin-top: 10px;">
                  <button (click)="guardarCompliance()"
                    style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">save</mat-icon> Guardar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- ═══ Sección: Sanciones persona ═══ -->
      <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">policy</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">
            Verificación de sanciones — {{ isCompany ? 'Representante legal' : 'Persona' }}
          </span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <!-- Loading -->
          <div *ngIf="sanctionsLoading" style="display: flex; align-items: center; gap: 10px; padding: 8px 0;">
            <mat-spinner diameter="28"></mat-spinner>
            <span style="color: #6b7280; font-size: 0.85rem;">Consultando listas de sanciones...</span>
          </div>

          <!-- Error -->
          <div *ngIf="!sanctionsLoading && sanctionsError"
            style="padding: 12px 14px; border-radius: 6px; background: #fff7ed; border: 1px solid #fed7aa;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
              <mat-icon style="color: #ea580c; font-size: 20px; width: 20px; height: 20px;">error_outline</mat-icon>
              <span style="color: #ea580c; font-weight: 600; font-size: 0.9rem;">{{ sanctionsError }}</span>
            </div>
            <button (click)="checkUserSanctions()"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
              onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">refresh</mat-icon> Reintentar
            </button>
          </div>

          <!-- Sin coincidencias -->
          <div *ngIf="!sanctionsLoading && !sanctionsError && sanctionsResult && !sanctionsResult.hasMatches && !sanctionsResult.countryRisk"
            style="display: flex; align-items: center; gap: 8px;">
            <mat-icon style="color: #16a34a; font-size: 20px; width: 20px; height: 20px;">verified_user</mat-icon>
            <span style="color: #16a34a; font-weight: 600; font-size: 0.9rem;">
              Esta persona no se encuentra en listas de sanciones
            </span>
            <span style="color: #6b7280; font-size: 0.75rem; margin-left: 4px;">
              ({{ sanctionsResult!.listsChecked.join(', ') }})
            </span>
          </div>

          <!-- Riesgo pais GAFI/FATF -->
          <div *ngIf="!sanctionsLoading && !sanctionsError && sanctionsResult?.countryRisk"
            style="padding: 12px 14px; border-radius: 6px; margin-bottom: 10px;"
            [style.background]="sanctionsResult!.countryRisk!.riskLevel === 'CRITICAL' ? '#fef2f2' : '#fff7ed'"
            [style.border]="'1px solid ' + (sanctionsResult!.countryRisk!.riskLevel === 'CRITICAL' ? '#fecaca' : '#fed7aa')">
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 6px;">
              <mat-icon [style.color]="sanctionsResult!.countryRisk!.riskLevel === 'CRITICAL' ? '#dc2626' : '#ea580c'"
                style="font-size: 20px; width: 20px; height: 20px;">public</mat-icon>
              <span style="font-weight: 600; font-size: 0.9rem;"
                [style.color]="sanctionsResult!.countryRisk!.riskLevel === 'CRITICAL' ? '#dc2626' : '#ea580c'">
                Riesgo por nacionalidad ({{ sanctionsResult!.countryRisk!.listName }})
              </span>
              <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                [style.background]="sanctionsResult!.countryRisk!.riskLevel === 'CRITICAL' ? '#dc2626' : '#ea580c'">
                {{ sanctionsResult!.countryRisk!.riskLevel }}
              </span>
            </div>
            <div style="font-size: 0.85rem; color: #374151;">
              <span style="font-weight: 500;">País: </span>{{ sanctionsResult!.countryRisk!.countryCode }}
              <span *ngIf="sanctionsResult!.countryRisk!.isBlackListed" style="margin-left: 12px;">
                <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white; background: #dc2626;">Lista Negra GAFI</span>
              </span>
              <span *ngIf="sanctionsResult!.countryRisk!.isGreyListed && !sanctionsResult!.countryRisk!.isBlackListed" style="margin-left: 12px;">
                <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white; background: #ea580c;">Lista Gris GAFI</span>
              </span>
            </div>
          </div>

          <!-- Sin coincidencias de nombre pero con riesgo pais -->
          <div *ngIf="!sanctionsLoading && !sanctionsError && sanctionsResult && !sanctionsResult.hasMatches && sanctionsResult.countryRisk"
            style="display: flex; align-items: center; gap: 8px; margin-top: 8px;">
            <mat-icon style="color: #16a34a; font-size: 20px; width: 20px; height: 20px;">verified_user</mat-icon>
            <span style="color: #16a34a; font-weight: 600; font-size: 0.9rem;">Sin coincidencias en listas por nombre</span>
            <span style="color: #6b7280; font-size: 0.75rem; margin-left: 4px;">
              ({{ sanctionsResult!.listsChecked.join(', ') }})
            </span>
          </div>

          <!-- Coincidencias encontradas -->
          <div *ngIf="!sanctionsLoading && !sanctionsError && sanctionsResult?.hasMatches">
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px;">warning</mat-icon>
              <span style="color: #dc2626; font-weight: 600; font-size: 0.95rem;">Coincidencias en listas de sanciones</span>
              <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                [style.background]="sanctionsResult!.riskLevel === 'CRITICAL' ? '#dc2626' : sanctionsResult!.riskLevel === 'HIGH' ? '#ea580c' : sanctionsResult!.riskLevel === 'MEDIUM' ? '#ca8a04' : '#16a34a'">
                {{ sanctionsResult!.riskLevel }}
              </span>
            </div>
            <div style="font-size: 0.8rem; color: #6b7280; margin-bottom: 10px;">
              Nombre: <strong>{{ sanctionsResult!.metadata.checkedName }}</strong>
              <span *ngIf="sanctionsResult!.metadata.checkedNationality">
                &mdash; Nacionalidad: <strong>{{ sanctionsResult!.metadata.checkedNationality }}</strong>
              </span>
              &mdash; Listas: {{ sanctionsResult!.listsChecked.join(', ') }}
            </div>

            <!-- Desktop table -->
            <div class="hidden md:block" style="overflow-x: auto; border: 1px solid #fecaca; border-radius: 6px;">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background-color: #fef2f2;">
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Lista</th>
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Nombre encontrado</th>
                    <th style="padding: 8px 12px; text-align: center; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Score</th>
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Tipo</th>
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Programas</th>
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Nacionalidad</th>
                    <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Observaciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let match of sanctionsResult!.matches" style="border-bottom: 1px solid #fecaca;">
                    <td style="padding: 8px 12px; font-size: 0.8rem; font-weight: 600;">{{ match.list }}</td>
                    <td style="padding: 8px 12px; font-size: 0.8rem;">
                      {{ match.matchedName }}
                      <div *ngIf="match.aliases?.length" style="font-size: 0.75rem; color: #6b7280; margin-top: 2px;">
                        Aliases: {{ match.aliases!.join(', ') }}
                      </div>
                    </td>
                    <td style="padding: 8px 12px; text-align: center;">
                      <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                        [style.background]="match.score >= 95 ? '#dc2626' : match.score >= 85 ? '#ea580c' : '#ca8a04'">
                        {{ match.score }}%
                      </span>
                    </td>
                    <td style="padding: 8px 12px; font-size: 0.8rem;">{{ match.type }}</td>
                    <td style="padding: 8px 12px; font-size: 0.8rem;">{{ match.programs.join(', ') }}</td>
                    <td style="padding: 8px 12px; font-size: 0.8rem;">{{ match.nationality || '-' }}</td>
                    <td style="padding: 8px 12px; font-size: 0.8rem;">{{ match.remarks || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile cards -->
            <div class="md:hidden grid grid-cols-1 gap-3">
              <div *ngFor="let match of sanctionsResult!.matches"
                style="border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 6px; padding: 12px;">
                <div class="grid grid-cols-1 gap-2" style="font-size: 0.85rem;">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span style="color: #991b1b; font-weight: 600;">{{ match.list }}</span>
                    <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                      [style.background]="match.score >= 95 ? '#dc2626' : match.score >= 85 ? '#ea580c' : '#ca8a04'">
                      {{ match.score }}%
                    </span>
                  </div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Nombre: </span>{{ match.matchedName }}</div>
                  <div *ngIf="match.aliases?.length"><span style="color: #6b7280; font-size: 0.8rem;">Aliases: </span><span style="font-size: 0.8rem; color: #374151;">{{ match.aliases!.join(', ') }}</span></div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Tipo: </span>{{ match.type }}</div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Programas: </span>{{ match.programs.join(', ') }}</div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Nacionalidad: </span>{{ match.nationality || '-' }}</div>
                  <div *ngIf="match.remarks"><span style="color: #6b7280; font-size: 0.8rem;">Observaciones: </span>{{ match.remarks }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: PEP Chile — Persona ═══ -->
      <div *ngIf="user?.tipoId !== 'VE'"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">account_balance</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">
            Verificación PEP Chile — {{ isCompany ? 'Representante legal' : 'Persona' }}
          </span>
        </div>
        <div style="padding: 16px 20px; background: white;">

          <!-- Loading -->
          <div *ngIf="pepChileLoading" style="display: flex; align-items: center; gap: 10px; padding: 8px 0;">
            <mat-spinner diameter="28"></mat-spinner>
            <span style="color: #6b7280; font-size: 0.85rem;">Consultando registros PEP Chile (Regcheq)...</span>
          </div>

          <!-- Error -->
          <div *ngIf="!pepChileLoading && pepChileError"
            style="padding: 12px 14px; border-radius: 6px; background: #fff7ed; border: 1px solid #fed7aa;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
              <mat-icon style="color: #ea580c; font-size: 20px; width: 20px; height: 20px;">error_outline</mat-icon>
              <span style="color: #ea580c; font-weight: 600; font-size: 0.9rem;">{{ pepChileError }}</span>
            </div>
            <button (click)="checkPepChile()"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
              onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">refresh</mat-icon> Reintentar
            </button>
          </div>

          <!-- Sin coincidencias PEP -->
          <div *ngIf="!pepChileLoading && !pepChileError && pepChileResult && !pepChileResult.isPep && !pepChileResult.isFuncionarioPublico"
            style="display: flex; align-items: center; gap: 8px;">
            <mat-icon style="color: #16a34a; font-size: 20px; width: 20px; height: 20px;">verified_user</mat-icon>
            <span style="color: #16a34a; font-weight: 600; font-size: 0.9rem;">
              No se encontraron registros PEP Chile para este RUT
            </span>
            <span style="color: #6b7280; font-size: 0.75rem; margin-left: 4px;">
              (RUT: {{ pepChileResult.dni }})
            </span>
          </div>

          <!-- Coincidencia PEP encontrada -->
          <div *ngIf="!pepChileLoading && !pepChileError && pepChileResult && (pepChileResult.isPep || pepChileResult.isFuncionarioPublico)">
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px;">warning</mat-icon>
              <span style="color: #dc2626; font-weight: 600; font-size: 0.95rem;">
                Persona Políticamente Expuesta (PEP Chile)
              </span>
              <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                [style.background]="pepChileResult.effectiveRisk === 'high' ? '#dc2626' : pepChileResult.effectiveRisk === 'medium' ? '#ca8a04' : '#8b5cf6'">
                {{ pepChileResult.effectiveRisk ? (pepChileResult.effectiveRisk | uppercase) : 'NIVEL ' + pepChileResult.pepLevel }}
              </span>
            </div>

            <!-- Datos resumen -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1" style="margin-bottom: 12px;">
              <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">RUT consultado</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ pepChileResult.dni }}</span>
              </div>
              <div *ngIf="pepChileResult.fullName" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nombre completo</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ pepChileResult.fullName }}</span>
              </div>
              <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Es PEP</span>
                <span style="font-weight: 600; font-size: 0.9rem;"
                  [style.color]="pepChileResult.isPep ? '#dc2626' : '#16a34a'">
                  {{ pepChileResult.isPep ? 'Sí' : 'No' }}
                </span>
              </div>
              <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Funcionario público</span>
                <span style="font-weight: 600; font-size: 0.9rem;"
                  [style.color]="pepChileResult.isFuncionarioPublico ? '#dc2626' : '#16a34a'">
                  {{ pepChileResult.isFuncionarioPublico ? 'Sí' : 'No' }}
                </span>
              </div>
              <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Nivel PEP</span>
                <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ pepChileResult.pepLevel }}</span>
              </div>
              <div *ngIf="pepChileResult.effectiveRisk" style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                <span style="color: #6b7280; font-size: 0.8rem; display: block;">Riesgo efectivo</span>
                <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                  [style.background]="pepChileResult.effectiveRisk === 'high' ? '#dc2626' : pepChileResult.effectiveRisk === 'medium' ? '#ca8a04' : '#16a34a'">
                  {{ pepChileResult.effectiveRisk | uppercase }}
                </span>
              </div>
            </div>

            <!-- Tabla de listas verificadas -->
            <div *ngIf="pepChileResult.listsChecked?.length" style="margin-top: 8px;">
              <span style="color: #374151; font-weight: 600; font-size: 0.85rem; display: block; margin-bottom: 6px;">
                Listas verificadas ({{ pepChileResult.listsChecked.length }})
              </span>

              <!-- Desktop table -->
              <div class="hidden md:block" style="overflow-x: auto; border: 1px solid #fecaca; border-radius: 6px;">
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr style="background-color: #fef2f2;">
                      <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Lista</th>
                      <th style="padding: 8px 12px; text-align: center; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Coincidencia</th>
                      <th style="padding: 8px 12px; text-align: center; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Riesgo</th>
                      <th style="padding: 8px 12px; text-align: left; font-size: 0.8rem; font-weight: 600; color: #991b1b; border-bottom: 2px solid #fecaca;">Última revisión</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let list of pepChileResult.listsChecked" style="border-bottom: 1px solid #fecaca;">
                      <td style="padding: 8px 12px; font-size: 0.8rem; font-weight: 600;">{{ list.listName }}</td>
                      <td style="padding: 8px 12px; text-align: center;">
                        <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                          [style.background]="list.coincidence ? '#dc2626' : '#16a34a'">
                          {{ list.coincidence ? 'Sí' : 'No' }}
                        </span>
                      </td>
                      <td style="padding: 8px 12px; text-align: center;">
                        <span *ngIf="list.risk" style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                          [style.background]="list.risk === 'high' ? '#dc2626' : list.risk === 'medium' ? '#ca8a04' : '#16a34a'">
                          {{ list.risk | uppercase }}
                        </span>
                        <span *ngIf="!list.risk" style="color: #6b7280; font-size: 0.8rem;">-</span>
                      </td>
                      <td style="padding: 8px 12px; font-size: 0.8rem;">{{ list.lastChecked || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Mobile cards -->
              <div class="md:hidden grid grid-cols-1 gap-3">
                <div *ngFor="let list of pepChileResult.listsChecked"
                  style="border: 1px solid #fecaca; border-left: 4px solid; border-radius: 6px; padding: 12px;"
                  [style.border-left-color]="list.coincidence ? '#dc2626' : '#16a34a'">
                  <div class="grid grid-cols-1 gap-2" style="font-size: 0.85rem;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                      <span style="color: #991b1b; font-weight: 600;">{{ list.listName }}</span>
                      <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                        [style.background]="list.coincidence ? '#dc2626' : '#16a34a'">
                        {{ list.coincidence ? 'Sí' : 'No' }}
                      </span>
                    </div>
                    <div *ngIf="list.risk"><span style="color: #6b7280; font-size: 0.8rem;">Riesgo: </span>
                      <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                        [style.background]="list.risk === 'high' ? '#dc2626' : list.risk === 'medium' ? '#ca8a04' : '#16a34a'">
                        {{ list.risk | uppercase }}
                      </span>
                    </div>
                    <div *ngIf="list.lastChecked"><span style="color: #6b7280; font-size: 0.8rem;">Última revisión: </span>{{ list.lastChecked }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Metadata -->
            <div style="margin-top: 10px; font-size: 0.75rem; color: #9ca3af;">
              Consultado: {{ pepChileResult.metadata.timestamp }} |
              RUT: {{ pepChileResult.metadata.checkedDni }} |
              Tiempo: {{ pepChileResult.metadata.processingTimeMs }}ms
            </div>
          </div>
        </div>
      </div>

      <!-- ═══ Sección: Sanciones Empresa (razón social) ═══ -->
      <div *ngIf="isCompany && user?.razonSocial"
        style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">domain_verification</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">
            Verificación sanciones — Razón Social
          </span>
          <span style="color: #6b7280; font-size: 0.85rem; font-weight: 400;">{{ user.razonSocial }}</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <!-- Loading -->
          <div *ngIf="companySanctionsLoading" style="display: flex; align-items: center; gap: 10px; padding: 8px 0;">
            <mat-spinner diameter="28"></mat-spinner>
            <span style="color: #6b7280; font-size: 0.85rem;">Consultando listas de sanciones para la empresa...</span>
          </div>

          <!-- Error -->
          <div *ngIf="!companySanctionsLoading && companySanctionsError"
            style="padding: 12px 14px; border-radius: 6px; background: #fff7ed; border: 1px solid #fed7aa;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
              <mat-icon style="color: #ea580c; font-size: 20px; width: 20px; height: 20px;">error_outline</mat-icon>
              <span style="color: #ea580c; font-weight: 600; font-size: 0.9rem;">{{ companySanctionsError }}</span>
            </div>
            <button (click)="checkCompanySanctions()"
              style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
              onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px;">refresh</mat-icon> Reintentar
            </button>
          </div>

          <!-- Sin coincidencias -->
          <div *ngIf="!companySanctionsLoading && !companySanctionsError && companySanctionsResult && !companySanctionsResult.hasMatches"
            style="display: flex; align-items: center; gap: 8px;">
            <mat-icon style="color: #16a34a; font-size: 20px; width: 20px; height: 20px;">verified_user</mat-icon>
            <span style="color: #16a34a; font-weight: 600; font-size: 0.9rem;">
              La empresa no se encuentra en listas de sanciones
            </span>
            <span style="color: #6b7280; font-size: 0.75rem; margin-left: 4px;">
              ({{ companySanctionsResult!.listsChecked.join(', ') }})
            </span>
          </div>

          <!-- Coincidencias -->
          <div *ngIf="!companySanctionsLoading && !companySanctionsError && companySanctionsResult?.hasMatches">
            <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="color: #dc2626; font-size: 20px; width: 20px; height: 20px;">warning</mat-icon>
              <span style="color: #dc2626; font-weight: 600; font-size: 0.95rem;">Coincidencias para la empresa</span>
              <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                [style.background]="companySanctionsResult!.riskLevel === 'CRITICAL' ? '#dc2626' : companySanctionsResult!.riskLevel === 'HIGH' ? '#ea580c' : companySanctionsResult!.riskLevel === 'MEDIUM' ? '#ca8a04' : '#16a34a'">
                {{ companySanctionsResult!.riskLevel }}
              </span>
            </div>
            <div class="grid grid-cols-1 gap-3">
              <div *ngFor="let match of companySanctionsResult!.matches"
                style="border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 6px; padding: 12px;">
                <div class="grid grid-cols-1 gap-2" style="font-size: 0.85rem;">
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span style="color: #991b1b; font-weight: 600;">{{ match.list }}</span>
                    <span style="padding: 2px 8px; border-radius: 20px; font-size: 0.75rem; font-weight: 600; color: white;"
                      [style.background]="match.score >= 95 ? '#dc2626' : match.score >= 85 ? '#ea580c' : '#ca8a04'">
                      {{ match.score }}%
                    </span>
                  </div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Nombre: </span>{{ match.matchedName }}</div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Tipo: </span>{{ match.type }}</div>
                  <div><span style="color: #6b7280; font-size: 0.8rem;">Programas: </span>{{ match.programs.join(', ') }}</div>
                  <div *ngIf="match.remarks"><span style="color: #6b7280; font-size: 0.8rem;">Observaciones: </span>{{ match.remarks }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </mat-tab>
  <mat-tab label="Datos residenciales" *ngIf="!isCompany">
    <div *ngIf="user" class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">
      <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden;">
        <div style="display: flex; align-items: center; gap: 10px; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">home</mat-icon>
          <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Datos residenciales</span>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">País residencia</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.paisResidencia }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Ciudad de residencia</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.ciudadResidencia }}</span>
            </div>
            <div style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
              <span style="color: #6b7280; font-size: 0.8rem; display: block;">Dirección</span>
              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ user.direccion }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Datos de pagadores">
    <div class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">
      <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 12px;">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 14px 20px; background: linear-gradient(135deg, #f0fdf4, #ecfdf5); border-bottom: 1px solid #d1d5db;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">people</mat-icon>
            <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">Pagadores registrados</span>
            <span *ngIf="pagadores.length" style="background: #e5e7eb; color: #374151; font-size: 0.75rem; padding: 1px 8px; border-radius: 10px;">
              {{ pagadores.length }}
            </span>
          </div>

          <!-- OCULTO por ahora: creación manual por operador. Se conserva para
               reactivarla luego. El flujo actual es por link generado por el cliente. -->
          <button *ngIf="false" (click)="openAddPayer()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px;">person_add_alt_1</mat-icon> Agregar
          </button>
        </div>
        <div style="padding: 16px 20px; background: white;">
          <app-list-payer
            *ngIf="pagadores.length; else noPayers"
            [setPagadores]="pagadores"
            (reloadAccountList)="reloadPagadores()"
          >
          </app-list-payer>
          <ng-template #noPayers>
            <div style="text-align: center; padding: 20px 0;">
              <mat-icon style="color: #d1d5db; font-size: 40px; width: 40px; height: 40px;">person_off</mat-icon>
              <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px;">Este usuario no ha registrado pagadores aún</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab
    label="Datos registro empresa"
    *ngIf="isCompany && companyRegistration.data?.companyDocuments"
  >
    <div class="mt-4 w-full" style="max-width: 900px; margin: 0 auto;">
      <ng-container
        *ngFor="let key of objectKeys(companyRegistration.data.companyDocuments)"
      >
        <ng-container
          *ngIf="
            companyRegistration.data.companyDocuments[key] &&
            key !== 'progress' && key !== 'id' && key !== 'userId' &&
            key !== 'createdAt' && key !== 'updatedAt' && key !== 'isCompleted'
          "
        >
          <!-- Accordion section -->
          <div style="border: 1px solid #d1d5db; border-radius: 8px; margin-bottom: 12px; overflow: hidden;">
            <!-- Header -->
            <div
              (click)="toggleExpand(key)"
              style="
                display: flex; align-items: center; justify-content: space-between;
                padding: 14px 20px; cursor: pointer; user-select: none;
                background: linear-gradient(135deg, #f0fdf4, #ecfdf5);
                border-bottom: 1px solid #d1d5db;
              "
              [style.border-bottom]="expanded[key] ? '1px solid #d1d5db' : 'none'"
            >
              <div style="display: flex; align-items: center; gap: 10px;">
                <mat-icon style="color: #1e5a3f; font-size: 22px; width: 22px; height: 22px;">
                  {{ key === 'data1' ? 'person' : key === 'data2' ? 'business' : key === 'data3' ? 'store' : key === 'data4' ? 'verified_user' : key === 'data5' ? 'group' : key === 'data6' ? 'folder_open' : 'check_circle' }}
                </mat-icon>
                <span style="color: #1e5a3f; font-weight: 600; font-size: 1rem;">
                  {{
                    key === 'data1' ? (isNewCompanyFlow ? 'Representante Legal' : 'Persona de contacto')
                    : key === 'data2' ? 'Persona Jurídica'
                    : key === 'data3' ? 'Información del negocio'
                    : key === 'data4' ? (isNewCompanyFlow ? 'Verificación de identidad' : 'Beneficiario final')
                    : key === 'data5' ? 'Socios y beneficiarios'
                    : key === 'data6' ? 'Documentación requerida'
                    : key === 'data7' ? (isNewCompanyFlow ? 'Confirmación' : 'Justificación')
                    : formatKey(key)
                  }}
                </span>
              </div>
              <mat-icon style="color: #6b7280; transition: transform 0.2s;"
                [style.transform]="expanded[key] ? 'rotate(180deg)' : 'rotate(0)'">
                expand_more
              </mat-icon>
            </div>

            <!-- Content -->
            <div *ngIf="expanded[key]" style="padding: 16px 20px; background: white;">

              <!-- ═══════ DATA6: Documentos + datos extra ═══════ -->
              <ng-container *ngIf="key === 'data6' && isPlainObject(companyRegistration.data.companyDocuments[key])">
                <!-- Documentos S3 (valores con '/') -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <ng-container *ngFor="let fileKey of objectKeys(companyRegistration.data.companyDocuments[key])">
                    <div *ngIf="isS3Path(companyRegistration.data.companyDocuments[key][fileKey])"
                      style="display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-radius: 6px; background: #f9fafb; border: 1px solid #e5e7eb;">
                      <mat-icon style="color: #1e5a3f; font-size: 20px; width: 20px; height: 20px;">description</mat-icon>
                      <span style="color: #374151; font-weight: 500; flex: 1; font-size: 0.9rem;">{{ formatKey(fileKey) }}</span>
                      <button (click)="openFilePreview(companyRegistration.data.companyDocuments[key][fileKey], formatKey(fileKey))"
                        style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
                        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
                      </button>
                    </div>
                  </ng-container>
                </div>
                <!-- Datos adicionales en data6 (no S3, ej: PEP) -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1" style="margin-top: 12px;">
                  <ng-container *ngFor="let fileKey of objectKeys(companyRegistration.data.companyDocuments[key])">
                    <div *ngIf="!isS3Path(companyRegistration.data.companyDocuments[key][fileKey]) && shouldShowField(fileKey, companyRegistration.data.companyDocuments[key][fileKey], key)"
                      style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                      <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(fileKey) }}</span>
                      <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ formatValue(fileKey, companyRegistration.data.companyDocuments[key][fileKey]) }}</span>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <!-- ═══════ DATA4 nuevo flujo: Verificación identidad ═══════ -->
              <ng-container *ngIf="key === 'data4' && isNewCompanyFlow && isPlainObject(companyRegistration.data.companyDocuments[key])">

                <!-- OCR -->
                <ng-container *ngIf="companyRegistration.data.companyDocuments.data4?.ocr?.campos">
                  <div style="font-weight: 600; color: #1e5a3f; margin-bottom: 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">document_scanner</mat-icon>
                    Resultado OCR
                  </div>
                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1" style="margin-bottom: 16px;">
                    <ng-container *ngFor="let ocrKey of objectKeys(companyRegistration.data.companyDocuments.data4.ocr.campos)">
                      <div style="padding: 4px 0; display: flex; gap: 6px;">
                        <span style="color: #6b7280; font-size: 0.85rem; min-width: 120px;">{{ formatKey(ocrKey) }}</span>
                        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ companyRegistration.data.companyDocuments.data4.ocr.campos[ocrKey] }}</span>
                      </div>
                    </ng-container>
                  </div>

                  <!-- Validación -->
                  <ng-container *ngIf="companyRegistration.data.companyDocuments.data4.ocr.validacion as val">
                    <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px;">
                      <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                        [style.background]="val.confianzaOCR >= 90 ? '#16a34a' : val.confianzaOCR >= 70 ? '#ca8a04' : '#dc2626'">
                        OCR {{ val.confianzaOCR }}%
                      </span>
                      <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                        [style.background]="val.runValido ? '#16a34a' : '#dc2626'">
                        RUN {{ val.runValido ? 'Válido' : 'Inválido' }}
                      </span>
                      <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                        [style.background]="!val.estaVencido ? '#16a34a' : '#dc2626'">
                        {{ val.estaVencido ? 'Vencido' : val.diasHastaVencimiento + ' días vigente' }}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>

                <!-- Verificación facial -->
                <ng-container *ngIf="companyRegistration.data.companyDocuments.data4?.facialVerification as face">
                  <div style="font-weight: 600; color: #1e5a3f; margin-bottom: 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">face</mat-icon>
                    Verificación facial
                  </div>
                  <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px;">
                    <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                      [style.background]="face.similarity >= 0.8 ? '#16a34a' : face.similarity >= 0.5 ? '#ca8a04' : '#dc2626'">
                      Similitud {{ (face.similarity * 100).toFixed(1) }}%
                    </span>
                    <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                      [style.background]="face.isMatch ? '#16a34a' : '#dc2626'">
                      {{ face.isMatch ? 'Coincide' : 'No coincide' }}
                    </span>
                  </div>
                </ng-container>

                <!-- Sanciones -->
                <ng-container *ngIf="companyRegistration.data.companyDocuments.data4?.ocr?.verificacionSanciones as sanc">
                  <div style="font-weight: 600; color: #1e5a3f; margin-bottom: 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">policy</mat-icon>
                    Verificación sanciones
                  </div>
                  <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 8px;">
                    <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                      [style.background]="!sanc.hasMatches ? '#16a34a' : '#dc2626'">
                      {{ sanc.hasMatches ? 'Con coincidencias' : 'Sin coincidencias' }}
                    </span>
                    <span style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white;"
                      [style.background]="sanc.riskLevel === 'CRITICAL' ? '#dc2626' : sanc.riskLevel === 'HIGH' ? '#ea580c' : sanc.riskLevel === 'MEDIUM' ? '#ca8a04' : '#16a34a'">
                      Riesgo {{ sanc.riskLevel }}
                    </span>
                    <ng-container *ngIf="sanc.countryRisk">
                      <span *ngIf="sanc.countryRisk.isGreyListed" style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #ea580c;">
                        {{ sanc.countryRisk.countryCode }} Lista Gris GAFI
                      </span>
                      <span *ngIf="sanc.countryRisk.isBlackListed" style="padding: 4px 12px; border-radius: 20px; font-size: 0.8rem; font-weight: 600; color: white; background: #dc2626;">
                        {{ sanc.countryRisk.countryCode }} Lista Negra GAFI
                      </span>
                    </ng-container>
                  </div>
                  <div style="font-size: 0.8rem; color: #6b7280; margin-bottom: 16px;">
                    Nombre: <strong>{{ sanc.metadata?.checkedName }}</strong>
                    &mdash; Listas: {{ sanc.listsChecked?.join(', ') }}
                  </div>
                </ng-container>

                <!-- S3 Documentos -->
                <ng-container *ngIf="companyRegistration.data.companyDocuments.data4?.s3Keys as s3">
                  <div style="font-weight: 600; color: #1e5a3f; margin-bottom: 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">photo_library</mat-icon>
                    Imágenes capturadas
                  </div>
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <ng-container *ngFor="let s3Key of objectKeys(s3)">
                      <button *ngIf="s3[s3Key]"
                        (click)="openFilePreview(s3[s3Key], formatKey(s3Key))"
                        style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb;"
                        onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
                        {{ formatKey(s3Key) }}
                      </button>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <!-- ═══════ DEFAULT: data1, data2, data3, data5, data7 y flujo viejo ═══════ -->
              <ng-container *ngIf="key !== 'data6' && !(key === 'data4' && isNewCompanyFlow)">
                <!-- Objeto plano -->
                <div *ngIf="isPlainObject(companyRegistration.data.companyDocuments[key])">
                  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
                    <ng-container *ngFor="let k of objectKeys(companyRegistration.data.companyDocuments[key])">
                      <ng-container *ngIf="shouldShowField(k, companyRegistration.data.companyDocuments[key][k], key)">
                        <!-- Valor simple (texto) -->
                        <div *ngIf="!isArray(companyRegistration.data.companyDocuments[key][k]) && !isS3Path(companyRegistration.data.companyDocuments[key][k])"
                          style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                          <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(k) }}</span>
                          <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">{{ formatValue(k, companyRegistration.data.companyDocuments[key][k]) }}</span>
                        </div>
                        <!-- Valor simple (archivo S3) -->
                        <div *ngIf="!isArray(companyRegistration.data.companyDocuments[key][k]) && isS3Path(companyRegistration.data.companyDocuments[key][k])"
                          style="padding: 5px 0; border-bottom: 1px solid #f3f4f6;">
                          <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(k) }}</span>
                          <button (click)="openFilePreview(companyRegistration.data.companyDocuments[key][k], formatKey(k))"
                            style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb; margin-top: 2px;"
                            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
                          </button>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                  <!-- Arrays dentro del objeto (beneficiarios, representantes, etc.) -->
                  <ng-container *ngFor="let k of objectKeys(companyRegistration.data.companyDocuments[key])">
                    <ng-container *ngIf="isArray(companyRegistration.data.companyDocuments[key][k]) && shouldShowField(k, companyRegistration.data.companyDocuments[key][k], key)">
                      <div style="font-weight: 600; color: #1e5a3f; margin: 16px 0 8px; font-size: 0.95rem; display: flex; align-items: center; gap: 6px;">
                        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">
                          {{ k === 'beneficiarios' ? 'people' : k === 'representantes' ? 'badge' : 'account_circle' }}
                        </mat-icon>
                        {{ formatKey(k) }}
                        <span style="background: #e5e7eb; color: #374151; font-size: 0.75rem; padding: 1px 8px; border-radius: 10px;">
                          {{ companyRegistration.data.companyDocuments[key][k].length }}
                        </span>
                      </div>
                      <div class="grid grid-cols-1 gap-3">
                        <div *ngFor="let arrItem of companyRegistration.data.companyDocuments[key][k]; let i = index"
                          style="border: 1px solid #e5e7eb; border-radius: 8px; padding: 14px; background: #fafafa;">
                          <div style="font-weight: 600; color: #374151; font-size: 0.85rem; margin-bottom: 8px;">
                            {{ formatKey(k) }} #{{ i + 1 }}
                          </div>
                          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
                            <ng-container *ngFor="let arrKey of objectKeys(arrItem)">
                              <div *ngIf="shouldShowField(arrKey, arrItem[arrKey], key)"
                                style="padding: 3px 0; border-bottom: 1px solid #f3f4f6;">
                                <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(arrKey) }}</span>
                                <ng-container *ngIf="isS3Path(arrItem[arrKey]); else arrPlainVal">
                                  <button (click)="openFilePreview(arrItem[arrKey], formatKey(arrKey))"
                                    style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb; margin-top: 2px;"
                                    onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                                    <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
                                  </button>
                                </ng-container>
                                <ng-template #arrPlainVal>
                                  <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
                                    <ng-container *ngIf="isPlainObject(arrItem[arrKey])">
                                      <ng-container *ngFor="let subKey of objectKeys(arrItem[arrKey])">
                                        <span *ngIf="shouldShowField(subKey, arrItem[arrKey][subKey], key)">
                                          {{ formatKey(subKey) }}: {{ formatValue(subKey, arrItem[arrKey][subKey]) }}<br/>
                                        </span>
                                      </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!isPlainObject(arrItem[arrKey])">
                                      {{ formatValue(arrKey, arrItem[arrKey]) }}
                                    </ng-container>
                                  </span>
                                </ng-template>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <!-- Array directo -->
                <div *ngIf="isArray(companyRegistration.data.companyDocuments[key])">
                  <div class="grid grid-cols-1 gap-3">
                    <div *ngFor="let item of companyRegistration.data.companyDocuments[key]; let i = index"
                      style="border: 1px solid #e5e7eb; border-radius: 8px; padding: 14px; background: #fafafa;">
                      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-1">
                        <ng-container *ngFor="let k of objectKeys(item)">
                          <div *ngIf="shouldShowField(k, item[k], key)"
                            style="padding: 3px 0; border-bottom: 1px solid #f3f4f6;">
                            <span style="color: #6b7280; font-size: 0.8rem; display: block;">{{ formatKey(k) }}</span>
                            <ng-container *ngIf="isS3Path(item[k]); else directPlainVal">
                              <button (click)="openFilePreview(item[k], formatKey(k))"
                                style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 4px 12px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 0.8rem; font-weight: 600; color: #2563eb; margin-top: 2px;"
                                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon> Ver
                              </button>
                            </ng-container>
                            <ng-template #directPlainVal>
                              <span style="color: #111827; font-weight: 500; font-size: 0.9rem;">
                                <ng-container *ngIf="isPlainObject(item[k])">
                                  <ng-container *ngFor="let subKey of objectKeys(item[k])">
                                    <span *ngIf="shouldShowField(subKey, item[k][subKey], key)">
                                      {{ formatKey(subKey) }}: {{ formatValue(subKey, item[k][subKey]) }}<br/>
                                    </span>
                                  </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!isPlainObject(item[k])">{{ formatValue(k, item[k]) }}</ng-container>
                              </span>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Valor primitivo -->
                <div *ngIf="!isPlainObject(companyRegistration.data.companyDocuments[key]) && !isArray(companyRegistration.data.companyDocuments[key])">
                  <span style="color: #111827; font-weight: 500;">{{ formatValue(key, companyRegistration.data.companyDocuments[key]) }}</span>
                </div>
              </ng-container>

            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </mat-tab>
</mat-tab-group>

<!-- Modal for file preview (fuera de los tabs para que funcione globalmente) -->
<div
  *ngIf="filePreviewUrl || filePreviewError"
  class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
  (click)="closeFilePreview()"
>
  <div
    class="bg-white rounded-lg shadow-lg p-4 sm:p-6 relative w-full max-w-2xl max-h-full overflow-auto"
    (click)="$event.stopPropagation()"
  >
    <button
      class="absolute top-2 right-2"
      (click)="closeFilePreview()"
      style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; z-index: 1;"
    >
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">close</mat-icon>
    </button>
    <div class="flex flex-col items-center">
      <h3 class="text-lg font-bold mb-4" style="color: #1e5a3f">
        {{ filePreviewName }}
      </h3>
      <ng-container *ngIf="filePreviewError">
        <div style="display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 32px 20px;">
          <mat-icon style="color: #9ca3af; font-size: 48px; width: 48px; height: 48px;">image_not_supported</mat-icon>
          <span style="color: #6b7280; font-size: 1rem;">No est&aacute; registrada la imagen</span>
        </div>
      </ng-container>
      <ng-container *ngIf="!filePreviewError && filePreviewType === 'image'">
        <img
          [src]="filePreviewUrl"
          alt="Preview"
          style="max-height: 80vh; max-width: 100%;"
          class="rounded"
          (error)="filePreviewError = true; filePreviewUrl = null"
        />
      </ng-container>
      <ng-container *ngIf="!filePreviewError && filePreviewType === 'iframe'">
        <iframe
          [src]="filePreviewUrl"
          class="w-full"
          style="height: 70vh;"
          frameborder="0"
        ></iframe>
      </ng-container>
    </div>
  </div>
</div>
